module.exports = __webpack_public_path__ + "img/horizontal.e3683f7f.jpg";